import Hero from "./components/Hero";
import LatestSection from "./components/LatestSection";
import CategorySection from "./components/CategorySection";
import HotSection from "./components/HotSection";
import RecommendedSection from "./components/RecommendedSection";
import TopicsSection from "./components/TopicsSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  return (
    <>
      <Hero />
      <LatestSection />
      <CategorySection />
      <HotSection />
      <RecommendedSection />
      <TopicsSection />
      <FaqSection />
      <CtaSection />
    </>
  );
}